import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { saveAdressePaie } from "../actions/chariotActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../CommandeInfo.css"; // You'll need to create this CSS file
import { useNavigate } from "react-router-dom";

const CommandeInfo = ({ route }) => {
  const dispatch = useDispatch();
  const { livraisonAdresse, varGlo } = useSelector((state) => state.chariot);
  const { client } = useSelector((state) => state.client);
  const { clients } = useSelector((state) => state.clientsListeState);

  const [adresse, setAdresse] = useState(livraisonAdresse?.adresse || "");
  const [ville, setVille] = useState(livraisonAdresse?.ville || "");
  const [codepostale, setCodePostale] = useState(
    livraisonAdresse?.codepostale || 1000
  );
  const [pays, setPays] = useState(livraisonAdresse?.pays || "");
  const [methodePaiement, setMethodePaiement] = useState("");
  const [tel, setTel] = useState(client?.tel_cli || 0);
  const [date_livraison, setDate] = useState(new Date());
  const [cmt, setCmt] = useState("");
  const navigate = useNavigate();
  const commandeHandler = () => {
    if (Object.keys(varGlo).length === 0) {
      alert("Il faut choisir un Client!");
    } else {
      dispatch(
        saveAdressePaie(
          { adresse, ville, codepostale, pays, tel },
          methodePaiement,
          date_livraison
        )
      );
      navigate("commandeRecap", {
        state: {
          cliR: varGlo?.cod_cli,
          commentaire: cmt,
        },
      });
    }
  };

  return (
    <div className="container">
      <button className="validate-button" onClick={commandeHandler}>
        <div className="validate-button-text">Lancer la Commande</div>
      </button>

      <div className="form-container">
        <div className="input-row">
          <label className="label">Méthode de paiement:</label>
          <input
            type="text"
            placeholder="Methode de paiement"
            value={methodePaiement}
            onChange={(e) => setMethodePaiement(e.target.value)}
            className="input"
          />
        </div>

        <div className="input-row">
          <label className="label">Adresse:</label>
          <input
            type="text"
            placeholder="Adresse"
            value={adresse}
            onChange={(e) => setAdresse(e.target.value)}
            className="input"
          />
        </div>

        <div className="input-row">
          <label className="label">Numéro Téléphone:</label>
          <input
            type="text"
            placeholder="Numero Téléphone"
            value={tel}
            onChange={(e) => setTel(e.target.value)}
            className="input"
          />
        </div>

        <div className="input-row">
          <label className="label">Date Livraison:</label>
          <div className="date-picker-container">
            <FontAwesomeIcon icon={faCalendarAlt} size="lg" color="#0A95FF" />
            <DatePicker
              selected={date_livraison}
              onChange={(date) => setDate(date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="dd/MM/yyyy HH:mm"
              className="date-picker-input"
            />
          </div>
        </div>

        <div className="comment-container">
          <textarea
            placeholder="Commentaire"
            value={cmt}
            onChange={(e) => setCmt(e.target.value)}
            className="comment-input"
          />
        </div>
      </div>
    </div>
  );
};

export default CommandeInfo;
